import { render } from "./SingleAppointment.vue?vue&type=template&id=bb1cfbb2"
import script from "./SingleAppointment.vue?vue&type=script&lang=js"
export * from "./SingleAppointment.vue?vue&type=script&lang=js"

import exportComponent from "/home/tuhin/Downloads/homeo/html/clientApp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__